import { MeasurementMetric } from '@kentik/ui-shared/query/query.types';

export const commonTrafficMetrics: { [name: string]: MeasurementMetric } = {
  both_bits_per_sec: {
    Popular: true,
    Type: 'int',
    Label: 'bits/s',
    ToBits: true,
    Column: 'both_bytes',
    Window: 'rate',
    Shared: true
  },
  in_bits_per_sec: {
    Type: 'int',
    Label: 'Ingress bits/s',
    ToBits: true,
    Column: 'in_bytes',
    Window: 'rate',
    Shared: true
  },
  out_bits_per_sec: {
    Type: 'int',
    Label: 'Egress bits/s',
    ToBits: true,
    Column: 'out_bytes',
    Window: 'rate',
    Shared: true
  },
  total_bytes: {
    Type: 'int',
    Unit: 'bytes',
    Label: 'Total Bytes',
    Column: 'both_bytes',
    Aggregate: 'sum',
    Shared: true
  },
  total_in_bytes: {
    Type: 'int',
    Unit: 'bytes',
    Label: 'Total Ingress Bytes',
    Column: 'in_bytes',
    Aggregate: 'sum',
    Shared: true
  },
  total_out_bytes: {
    Type: 'int',
    Unit: 'bytes',
    Label: 'Total Egress Bytes',
    Column: 'out_bytes',
    Aggregate: 'sum',
    Shared: true
  },
  both_pkts_per_sec: {
    Popular: true,
    Type: 'int',
    Label: 'packets/s',
    Column: 'both_pkts',
    Window: 'rate',
    Shared: true
  },
  in_pkts_per_sec: {
    Type: 'int',
    Label: 'Ingress packets/s',
    Column: 'in_pkts',
    Window: 'rate',
    Shared: true
  },
  out_pkts_per_sec: {
    Type: 'int',
    Label: 'Egress packets/s',
    Column: 'out_pkts',
    Window: 'rate',
    Shared: true
  },
  total_packets: {
    Type: 'int',
    Unit: 'packets',
    Label: 'Total Packets',
    Column: 'both_pkts',
    Aggregate: 'sum',
    Shared: true
  },
  total_in_packets: {
    Type: 'int',
    Unit: 'packets',
    Label: 'Total Ingress Packets',
    Column: 'in_pkts',
    Aggregate: 'sum',
    Shared: true
  },
  total_out_packets: {
    Type: 'int',
    Unit: 'packets',
    Label: 'Total Egress Packets',
    Column: 'out_pkts',
    Aggregate: 'sum',
    Shared: true
  },
  fps: {
    Popular: true,
    Type: 'int',
    Label: 'flows/s',
    Column: 'i_count',
    Alias: 'trautocount',
    Window: 'rate',
    Shared: true
  },
  total_fps: {
    Type: 'int',
    Label: 'Total Flows',
    Column: 'i_count',
    Alias: 'trautocount',
    Aggregate: 'sum',
    Shared: true
  },
  bytes_per_src_ip: {
    Category: 'Unique',
    Type: 'int',
    Unit: 'bits/s',
    Label: 'Bitrate Per Source IP',
    Column: 'both_bytes',
    Expression: 'sum(both_bytes) / GREATEST(kt_hll_cardinality(inet_src_addr), 1)',
    DependsOn: [
      'sum(both_bytes) AS "f_sum_both_bytes"',
      'kt_hll_cardinality(inet_src_addr) as "f_hll(inet_src_addr,0.0001)"'
    ],
    ToBits: true,
    Window: 'rate',
    Shared: true
  },
  total_bytes_per_src_ip: {
    Category: 'Unique',
    Type: 'int',
    Unit: 'bytes',
    Label: 'Total Bytes Per Source IP',
    Column: 'both_bytes',
    Expression: 'sum(both_bytes) / GREATEST(kt_hll_cardinality(inet_src_addr), 1)',
    DependsOn: [
      'sum(both_bytes) AS "f_sum_both_bytes"',
      'kt_hll_cardinality(inet_src_addr) as "f_hll(inet_src_addr,0.0001)"'
    ],
    Aggregate: 'sum',
    Shared: true
  },
  bytes_per_dst_ip: {
    Category: 'Unique',
    Type: 'int',
    Unit: 'bits/s',
    Label: 'Bitrate Per Destination IP',
    Column: 'both_bytes',
    Expression: 'sum(both_bytes) / GREATEST(kt_hll_cardinality(inet_dst_addr), 1)',
    DependsOn: [
      'sum(both_bytes) AS "f_sum_both_bytes"',
      'kt_hll_cardinality(inet_dst_addr) as "f_hll(inet_dst_addr,0.0001)"'
    ],
    ToBits: true,
    Window: 'rate',
    Shared: true
  },
  max_sample_rate: {
    Type: 'int',
    Label: 'Max Sample Rate',
    Column: 'sample_rate',
    Window: 'max',
    Shared: true
  },
  avg_sample_rate: {
    Type: 'int',
    Label: 'Average Sample Rate',
    Column: 'sample_rate',
    Window: 'avg',
    Shared: true
  }
};
